"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualTransferExpenseOrderFields = exports.TransferMethod = exports.TransferType = void 0;
var TransferType;
(function (TransferType) {
    /** @deprecated use `REPAYMENT` instead */
    TransferType["CASH_HANDOVER"] = "CASH_HANDOVER";
    TransferType["REIMBURSEMENT"] = "REIMBURSEMENT";
    TransferType["REPAYMENT"] = "REPAYMENT";
})(TransferType = exports.TransferType || (exports.TransferType = {}));
var TransferMethod;
(function (TransferMethod) {
    TransferMethod["IN_PERSON"] = "IN_PERSON";
    TransferMethod["IN_SALARY"] = "IN_SALARY";
    TransferMethod["BANK_TRANSFER"] = "BANK_TRANSFER";
    TransferMethod["CASH"] = "CASH";
    TransferMethod["OTHER"] = "OTHER";
})(TransferMethod = exports.TransferMethod || (exports.TransferMethod = {}));
var ManualTransferExpenseOrderFields;
(function (ManualTransferExpenseOrderFields) {
    ManualTransferExpenseOrderFields["CREATED_AT"] = "createdAt";
    ManualTransferExpenseOrderFields["PERFORMED"] = "performed";
})(ManualTransferExpenseOrderFields = exports.ManualTransferExpenseOrderFields || (exports.ManualTransferExpenseOrderFields = {}));
//# sourceMappingURL=manual-transfer.js.map